module.exports = __webpack_public_path__ + "img/rectangle_light.3d5b261b.png";